/* eslint
@typescript-eslint/no-explicit-any:off,
@typescript-eslint/no-unsafe-member-access:off ,
@typescript-eslint/no-unsafe-assignment:off,
@typescript-eslint/no-unsafe-argument:off
*/
import axios from 'axios';
export const get = ({ token, url, misc }) => {
    return axios(Object.assign({ url, method: 'GET', headers: { Authorization: token } }, (misc ? misc : {})));
};
export const post = ({ token, url, data, handlers, misc }) => {
    const file = new FormData();
    let isFile = false;
    if (data instanceof File) {
        file.append('file', data);
        isFile = true;
    }
    else if ((data === null || data === void 0 ? void 0 : data.file) && (data === null || data === void 0 ? void 0 : data.file) instanceof File) {
        Object.keys(data).forEach((key) => {
            file.append(key, typeof data[key] === 'object' && key !== 'file'
                ? JSON.stringify(data[key])
                : data[key]);
        });
        isFile = true;
    }
    return axios(Object.assign(Object.assign({ method: 'POST', url, data: isFile ? file : data, headers: { Authorization: token } }, (handlers
        ? {
            onUploadProgress: (e) => {
                if (handlers.onUploadProgress) {
                    handlers.onUploadProgress(Math.round((e.loaded * 100) / e.total));
                }
            }
        }
        : {})), (misc ? misc : {})));
};
export const patch = ({ token, url, data }) => {
    return axios({
        method: 'PATCH',
        url,
        data,
        headers: { Authorization: token }
    });
};
export const del = ({ token, url, data }) => {
    return axios(Object.assign(Object.assign({ method: 'DELETE', url }, (data ? { data } : {})), { headers: { Authorization: token } }));
};
export default {
    get,
    post,
    patch,
    del
};
//# sourceMappingURL=index.js.map